// Assumes you are importing via build directory
import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider'

window.addEventListener('frame-ready', init)

function init() {

    let wrappers = Array.from(document.querySelectorAll(".inline-slider-wrapper"));
    let sliders = Array.from(document.querySelectorAll(".simple-slider-wrapper"));

    if (wrappers.length > 0) {

        wrappers.forEach(wrapper => {
            let slider = wrapper.querySelector('.inline-slider')

            tns({
                container: slider,
                nav: false,
                controlsContainer: wrapper.querySelector('.inline-slider--controls'),
                gutter: 40,
            })
        })
    }

    if (sliders.length > 0) {

        sliders.forEach(simple => {
            let slider = simple.querySelector('.simple-slider')

            tns({
                container: slider,
                nav: false,
                controlsContainer: simple.querySelector('.simple-slider--controls')
            })
        })
    }
}
